export default __webpack_public_path__ + "static/media/location.baac300e.svg";